import {PatreonPage} from "../features/patreon/PatreonPage"

export default PatreonPage.Page
